import React, { useContext } from "react"; 
import classes from "./ValidationErrorDisplay.module.css";
import { next_page } from "../Utility";
import { UserApiContext } from "../../../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../../../../src/MyCompanyProfileContext";
import { useMixPanelForTracking } from "../../../../../../utils/TrackMixPanel";

const ValidationErrorDisplay = ({ errorResponse, setMainStep, setData, setFile, setFinalKeys, setFloatFromFM, setSelectedFileFormat, setUploadedFileFormat }) => {

  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  const validation_errors = errorResponse?.validation_errors || {};

  const formatErrors = (errors) => {
    return Object.entries(errors).map(([errorType, fields], idx) => (
      <div
        key={idx}
        style={{ flex: 1, padding: "0 10px", minWidth: "300px" }} // Equal columns
        className={classes.errorblock}
      >
        <p style={{ fontSize: "15px", color: "red", fontWeight: "bold" }}>
          {errorType}
        </p>
        {Object.entries(fields).map(([fieldName, rows], i) => (
          <ul key={i}>
            {rows.map((row, j) => (
              <li key={j}>
                {row}: {fieldName} cannot be empty
              </li>
            ))}
          </ul>
        ))}
      </div>
    ));
  };

  const onReupload = () => {
    TrackMixPanel({
      ModuleName: "masters",
      ScreenName: "freight master bulk upload - step 1",
      Definition: "user clicked go back and reupload file due to validation errors",
      Data: `Number of error types: ${Object.keys(validation_errors).length}`,
    });

    setFile(null)
    setData([]);
    setFinalKeys({});
    setFloatFromFM("yes");
    setMainStep(0);
    setUploadedFileFormat([])
    setSelectedFileFormat([])
    next_page({
      data: "completed",
      excel_id: localStorage.getItem("fm_excel_id") ?? "",
      key: "page",
    });
    
  };

  return (
    <>
      <div className={classes.validationerrorcontainer}>
        {Object.keys(validation_errors).length > 0 ? (
          <>
            <p style={{ fontSize: "17px", fontWeight: "bold" }} className="m-0">
              File Validation Errors
            </p>
            <div style={{ display: "flex", gap: "20px" }}>
              {" "}
              {/* 3-column layout */}
              {formatErrors(validation_errors)}
            </div>
          </>
        ) : (
          <p>No validation errors found</p>
        )}
      </div>
      <div className="d-flex justify-content-center">
        <button onClick={onReupload} className={classes.reuploadbtn}>
          Go Back & Reupload File
        </button>
      </div>
    </>
  );
};

export default ValidationErrorDisplay;
